import './polyfill-env';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import BurialPointProvider from '../components/burial-point-provider';
import { spaRouter } from './router';
import { prefetchShellStylesheets } from './shell-styles';
import './spa.css';

// 入口尽早拉壳 CSS，与 API 并行，减少刷新白屏/无样式闪烁
void prefetchShellStylesheets();

const root = document.getElementById('root');
if (!root) {
  throw new Error('SPA root #root not found');
}

createRoot(root).render(
  <StrictMode>
    <BurialPointProvider>
      <RouterProvider router={spaRouter} />
    </BurialPointProvider>
  </StrictMode>,
);
